import {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {Link} from 'react-router-dom'

type BlogPost = {
  title: string
  slug: string
  featured_image: string | null
}

type GoriBlogProps = {
  slug?: string
}

export function GoriBlog({slug}: GoriBlogProps) {
  const intl = useIntl()
  const [post, setPost] = useState<BlogPost | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false

    async function fetchPost() {
      try {
        const apiUrl = process.env.REACT_APP_API_URL || ''
        const url = `${apiUrl}/api/blog/post${slug ? `?slug=${encodeURIComponent(slug)}` : ''}`

        const res = await fetch(url)

        if (!res.ok) throw new Error('Failed to fetch')

        const data = await res.json()

        if (!cancelled) {
          setPost(data)
          setLoading(false)
        }
      } catch (err) {
        console.error('Error fetching blog post:', err)
        if (!cancelled) {
          setPost(null)
          setLoading(false)
        }
      }
    }

    fetchPost()
    return () => {
      cancelled = true
    }
  }, [slug])

  if (loading) return null

  const href = post?.slug ? `/resources/blog/${post.slug}` : '/blog'
  const title = post?.title ?? 'Loading...'

  return (
    <Link
      to={href}
      className='banner-card d-flex justify-content-center rounded-4 border border-primary mx-auto py-12 px-18'
    >
      <div>
        <h3 className='mb-15 text-primary fw-bold'>{intl.formatMessage({id: 'BLOG'})}</h3>
        <p className='fw-bold gray-text'>
          {post && slug
            ? intl.formatMessage({id: 'RELATED_ARTICLE'})
            : intl.formatMessage({id: 'MOST_RECENT_ARTICLE'})}
        </p>
        <p className='fw-bold limit-text-length' dangerouslySetInnerHTML={{__html: title}} />
      </div>

      <div className='img-container'>
        {post?.featured_image ? (
          <img src={post.featured_image} title={title} alt={title} className='rounded-2' />
        ) : (
          <p>No image</p>
        )}
      </div>
    </Link>
  )
}
